import { html, LitElement, css } from 'lit';
import { customElement } from 'lit/decorators.js';
import { getGlobalStyleSheets } from '../../global-styles';

import * as Tags from './user-menus.tagnames';

@customElement(Tags.UserProfileMenuDivider)
export class AtlUserProfileMenuDivider extends LitElement {
  static styles = [
    ...getGlobalStyleSheets(),
    css`
      :host {
        display: block;
        overflow: hidden;
      }
      hr.dropdown-divider {
        border-top-color: var(--tti-user-profile-menu-status-title-dropdown-border-color);
      }
    `,
  ];

  render() {
    return html`<hr class="menu-divider dropdown-divider my-0">`;
  }
}
